// extracted by css-extract-rspack-plugin
export default {"label":"_62eadfad","container":"_d9aeeb2c","inset":"_18e13bae"};